module.exports = __webpack_public_path__ + "media/images/icon_email-1346985c7aaceb601b0d4257133254f4.svg";